import React from "react";
import styled from "styled-components";
import { breakpoints } from "../../../utils/styles";

const Container = styled.div<{movie: any}>`
    ${props => props.movie && ('colors' in props.movie) && `
        @media screen and (max-width: ${breakpoints.tablet}px) {
            body.theme-traditional &.confirmation-container {
                ${props.movie.colors.traditional.background ? `--local-page-bg: ${props.movie.colors.traditional.background};` : ''}
                ${props.movie.colors.traditional.text ? `--local-text-primary: ${props.movie.colors.traditional.text};` : ''}
                ${props.movie.colors.traditional.accent ? `--local-accent: ${props.movie.colors.traditional.accent};` : ''}
            }
        }
    `}
`;

interface Props {
    movie?: any;
    children: React.ReactNode;
}

function ConfirmationContainer(props: Props) {
    return (
        <Container className="confirmation-container" movie={props.movie}>
            {props.children}
        </Container>
    );
}

export default ConfirmationContainer;